import React from 'react';

// Color-coding count legend used by the first 3 sub-tabs (Excel reference)
export const STATUS_COLORS = {
  DONE:      { bg: '#00B050', fg: '#ffffff' },
  INPROCESS: { bg: '#FFFF00', fg: '#000000' },
  PENDING:   { bg: '#FFA500', fg: '#ffffff' },
  HOLD:      { bg: '#4169E1', fg: '#ffffff' },
  CANCEL:    { bg: '#FF0000', fg: '#ffffff' },
};

export const STATUSES = ['DONE', 'INPROCESS', 'PENDING', 'HOLD', 'CANCEL'];

// ── Daily Work / Daily Schedule auto-status color coding ──────────────────
export const AUTO_COLORS = {
  DONE:    { bg: '#00B050', fg: '#ffffff', label: 'Done' },
  ABSENT:  { bg: '#4472C4', fg: '#ffffff', label: 'Absent' },
  PENDING: { bg: '#FF0000', fg: '#ffffff', label: 'Pending' },
};

export const AutoStatusLegend = ({ counts = {} }) => {
  const total = (counts.DONE || 0) + (counts.ABSENT || 0) + (counts.PENDING || 0);
  return (
    <div className="flex flex-wrap items-center gap-3 mb-3 p-2 bg-stone-50 border border-stone-200 rounded">
      <span className="text-[11px] font-semibold text-stone-600 mr-1">COLOR CODING COUNT:</span>
      {Object.entries(AUTO_COLORS).map(([k, c]) => (
        <div key={k} className="flex items-center gap-1.5 text-[11px]">
          <span className="px-2 py-0.5 rounded font-bold text-[10px]" style={{ backgroundColor: c.bg, color: c.fg }}>{c.label}</span>
          <span className="font-bold text-stone-700">{counts[k] || 0}</span>
        </div>
      ))}
      <span className="ml-auto text-[11px] text-stone-500">
        TOTAL FILLED: <span className="font-bold text-stone-800">{counts.DONE || 0}</span>
      </span>
    </div>
  );
};
export const ADVANCE_COLORS = {
  C100: { bg: '#00B050', fg: '#ffffff', label: '100%', pct: 100 },  // Dark Green
  C75:  { bg: '#92D050', fg: '#000000', label: '75%',  pct: 75  },  // Light Green
  C50:  { bg: '#FFFF00', fg: '#000000', label: '50%',  pct: 50  },  // Yellow
  C20:  { bg: '#4472C4', fg: '#ffffff', label: '20%',  pct: 20  },  // Blue
  C0:   { bg: '#FF0000', fg: '#ffffff', label: '0%',   pct: 0   },  // Red
};
export const ADVANCE_STATUS_KEYS = Object.keys(ADVANCE_COLORS);

export const ColorCodingLegend = ({ counts = {} }) => {
  const total = Object.values(counts).reduce((s, n) => s + (n || 0), 0);
  return (
    <div className="flex flex-wrap items-center gap-2 mb-3 p-2 bg-stone-50 border border-stone-200 rounded">
      <span className="text-[11px] font-semibold text-stone-600 mr-1">COLOR CODING COUNT:</span>
      {Object.entries(STATUS_COLORS).map(([k, c]) => (
        <div key={k} className="flex items-center gap-1.5 text-[11px]">
          <span className="px-2 py-0.5 rounded font-bold text-[10px]" style={{ backgroundColor: c.bg, color: c.fg }}>{k}</span>
          <span className="text-stone-700 font-bold">{counts[k] || 0}</span>
        </div>
      ))}
      <span className="ml-auto text-[11px] text-stone-500">
        TOTAL: <span className="font-bold text-stone-800">{total}</span>
      </span>
    </div>
  );
};

// ── Advance (percentage) color coding legend ───────────────────────────────
export const AdvanceColorLegend = ({ counts = {} }) => {
  const total = Object.values(counts).reduce((s, n) => s + (n || 0), 0);
  return (
    <div className="flex flex-wrap items-center gap-3 mb-3 p-2 bg-stone-50 border border-stone-200 rounded">
      <span className="text-[11px] font-semibold text-stone-600 mr-1">COLOR CODING COUNT:</span>
      {Object.entries(ADVANCE_COLORS).map(([k, c]) => (
        <div key={k} className="flex items-center gap-1.5 text-[11px]">
          <span
            className="w-5 h-5 rounded-full inline-block border border-stone-300"
            style={{ backgroundColor: c.bg }}
            title={c.label}
          />
          <span className="font-bold text-stone-700">{c.label}</span>
          <span className="text-stone-500">{counts[k] || 0}</span>
        </div>
      ))}
      <span className="ml-auto text-[11px] text-stone-500">
        TOTAL: <span className="font-bold text-stone-800">{total}</span>
      </span>
    </div>
  );
};

